<template>
    <div data-testid="statistics-page">
        <div class="row justify-content-center p-1">
            <button @click="previousMonth()" type="button" class="btn btn-sm btn-primary" title="Předchozí měsíc" data-testid="statistics-previous-month"><i class="fa fa-arrow-left"></i></button>
            <datepicker v-model="selectedDate" placeholder="vybrat datum" format="MMMM yyyy" language="cs" :disabled="disableFutureDates" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datePickerBorderLessInput" v-on:input="loadMonthStatistics()" :minimumView="'month'" :maximumView="'year'" :initialView="'month'"></datepicker>
            <button v-if="$moment(selectedDate).format('YYYYMM') < $moment().format('YYYYMM')" @click="nextMonth()" type="button" class="btn btn-sm btn-primary" title="Následující měsíc" data-testid="statistics-next-month"><i class="fa fa-arrow-right"></i></button>
            <button v-else="" type="button" class="btn btn-sm btn-primary disabled" title="Následující měsíc" disabled="disabled" data-testid="statistics-next-month"><i class="fa fa-arrow-right"></i></button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <div class="row">
                            <div class="col-md-4">

                            </div>
                        </div>
                    </div> -->
                    <div class="card-body">
                               <insurance-month-bar-chart v-if="monthStatistics" :labels="monthStatistics.labels" :reload="monthStatisticsDone" :datasets="monthStatistics.per_company"></insurance-month-bar-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h5>pojišťovny</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-hover" v-if="monthStatistics" data-testid="statistics-insurance-table">
                            <thead>
                                <tr>
                                    <th>pojišťovna</th>
                                    <th>body</th>
                                    <th>počet návštěv</th>
                                    <th>průměrná výtěžnost b/n</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="company in monthStatistics.per_company">
                                    <td>{{ company.label }}</td>
                                    <td>{{ company.total }}</td>
                                    <td>{{ company.visit_counts }}</td>
                                    <td>{{ Math.round(company.total / company.visit_counts) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td><b>celkem</b></td>
                                    <td><b>{{ monthStatistics.total.total }}</b></td>
                                    <td><b>{{ monthStatistics.total.visit_counts }}</b></td>
                                    <td><b>{{ Math.round(monthStatistics.total.total / monthStatistics.total.visit_counts) }}</b></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h5>doktoři</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-hover" v-if="monthStatistics" data-testid="statistics-doctor-table">
                            <thead>
                            <tr>
                                <th>doktor</th>
                                <th>body</th>
                                <th>počet návštěv</th>
                                <th>průměrná výtěžnost b/n</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="doctor in monthStatistics.per_doctors">
                                <td>{{ doctor.label }}</td>
                                <td>{{ doctor.total }}</td>
                                <td>{{ doctor.visit_counts }}</td>
                                <td>{{ Math.round(doctor.total / doctor.visit_counts) }}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td><b>celkem</b></td>
                                <td><b>{{ monthStatistics.total.total }}</b></td>
                                <td><b>{{ monthStatistics.total.visit_counts }}</b></td>
                                <td><b>{{ Math.round(monthStatistics.total.total / monthStatistics.total.visit_counts) }}</b></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <h5>výkony</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-hover" v-if="monthStatistics" data-testid="statistics-operation-table">
                            <thead>
                            <tr>
                                <th>výkon</th>
                                <th>body</th>
                                <th>počet</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="operation in monthStatistics.per_operations">
                                <td :title="operation.title">{{ operation.label }}</td>
                                <td>{{ operation.points }}</td>
                                <td>{{ operation.count }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import InsuranceMonthBarChart from '../charts/InsuranceMonthBarChart'

  export default {
    data () {
      return {
        disableFutureDates: {
          from: this.$moment().add(1, 'd').toDate()
        },
        selectedDate: this.$moment().toDate(),
        // Load month statistics
        monthStatistics: false,
        monthStatisticsPending: true,
        monthStatisticsDone: false,
        monthStatisticsError: false
      }
    },
    mixins: [apiMixin],
    methods: {
      loadMonthStatistics () {
        let getParams = {
          date: this.$moment(this.selectedDate).format('MM.YYYY')
        }
        this.getMonthStatistics(getParams)
      },
      previousMonth () {
        this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'months').toDate()
        this.loadMonthStatistics()
      },
      nextMonth () {
        this.selectedDate = this.$moment(this.selectedDate).add(1, 'months').toDate()
        this.loadMonthStatistics()
      },
      init () {
        this.loadMonthStatistics()
      }
    },
    watch: {
      doctorId (val) {
        this.visits = false
        if (val !== null && val !== undefined) {
          document.title = 'clinico - ' + this.doctors.find(this.findDoctorById).fullname
          this.loadCalendar()
        }
      }
    },
    beforeMount () {
      this.init()
    },
    components: {
      InsuranceMonthBarChart
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    table.table_calendar td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Statistic/components/Statistic.vue?4e88651c